<template>
  <div class="gap-general">
    <SmallBanner
      :icon="'event'"
      :title="$t('forex-economic-calendar.title')"
      :description="$t('forex-economic-calendar.description')"
    />
    <div class="margin-general var-tables margin-less">
      <div id="economicCalendarWidget"></div>
    </div>

    <client-only>
      <LazyInvestment
        class="investment var-invest-two"
        :label="'forex-contract-specs.ready'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'forex-contract-specs.btn'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

import SmallBanner from "~/components/SmallBanner.vue";

const { getExternalUrl } = useExternalUrl();
const { t } = useI18n();

const title = t("seo.trading-conditions.forex.economic-calendar.title");
const description = t(
  "seo.trading-conditions.forex.economic-calendar.description"
);

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
});

onMounted(() => {
  const script = document.createElement("script");
  script.async = true;
  script.type = "text/javascript";
  script.dataset.type = "calendar-widget";
  script.src = "https://www.tradays.com/c/js/widgets/calendar/widget.js?v=13";
  script.innerHTML = '{"width":"100%","height":"100%","mode":"2"}';

  document.getElementById("economicCalendarWidget").appendChild(script);
});
</script>
